import { Tr, Td, Divider } from "@chakra-ui/react";
import { useComparePageContext } from "../../shared/state/ComparePageContext";

export function DividerRow() {
  const { scenarios } = useComparePageContext();

  return (
    <Tr className="prevent-hover">
      <Td />
      <Td />
      {scenarios.map((s) => (
        <Td key={s.id}>
          <Divider my={2} />
        </Td>
      ))}
    </Tr>
  );
}
